import React from "react";

const Popup = ({ isOpen, onClose, cross = true, small = false, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75">
      <div
        className={`bg-black px-8 py-12 rounded-lg shadow-lg relative w-[90%] md:w-4/5 xl:w-3/4 border border-orange scrollbar-hide ${
          small ? "xl:w-1/3" : ""
        }`}
      >
        {cross && (
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-600 hover:text-gray-800"
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="#EA5B0C"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Popup;
